// extracted by mini-css-extract-plugin
module.exports = {"submit":"update-password_submit__2zvvg","showPasswordIcon":"update-password_showPasswordIcon__23G6E","passwordStrength":"update-password_passwordStrength__2Z6GK"};